<div class="container">
  <nav class="account-details-nav d-flex flex-row align-items-center">
    <a class="nav-item" [routerLink]="['/account']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
      <label>{{ 'account.nav.profile' | translate }}</label>
    </a>
    <a class="nav-item" [routerLink]="['/activity']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
      <label>{{ 'account.nav.activity' | translate }}</label>
    </a>
  </nav>
</div>
